<script setup lang="ts">
import { Tooltip, Button } from 'ant-design-vue';
import { CloseCircleFilled } from '@ant-design/icons-vue';

withDefaults(
  defineProps<{
  disabled?: boolean,
  showRemove?: boolean,
  title?: string,
  onClick:() => void,
  onRemove:() => void,
}>(),
  {
    title: 'Remove',
  },
);
</script>
<template>
  <div
    class="relative flex"
  >
    <Button
      :disabled="disabled"
      class="text-left flex-1  pr-6"
      data-testid="input-button"
      @click="onClick"
    >
      <slot />
    </Button>
    <div v-if="showRemove && !disabled" class="absolute right-2 top-1.5">
      <Tooltip :title="title">
        <button
          class="opacity-30"
          type="button"
          :disabled="disabled"
          @click="onRemove"
        >
          <CloseCircleFilled />
        </button>
      </Tooltip>
    </div>
  </div>
</template>
